import { render } from "./clients.vue?vue&type=template&id=6988f003&scoped=true&ts=true"
import script from "./clients.vue?vue&type=script&lang=ts"
export * from "./clients.vue?vue&type=script&lang=ts"

import "./clients.vue?vue&type=style&index=0&id=6988f003&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6988f003"]])

export default __exports__